/**
 * R24 · Kopf-Suche (Vorschlaege, Zuletzt gesucht, SKU direkt zum Produkt)
 *
 * Ausgelagert aus sections/r24-header-2026.liquid (perf/pdp-weight, 23.09.2026):
 * vorher ~15 KB Inline-Skript in JEDER Seite, das den Parser mitten im Kopf
 * anhielt. Jetzt eine gecachte Datei mit `defer` — sie laeuft nach dem Parsen,
 * vor DOMContentLoaded. Das Skript bindet nur Ereignisse an die Suchformulare
 * (.r24hd-search__form, gibt es nur im Kopf); bis es laeuft, sendet das Formular
 * ganz normal an /search. Kein Liquid in dieser Datei.
 */
/* ---- R24 Predictive Search: /search/suggest.json inkl. variants.sku (SKU-/Artikelnummer-Suche),
        Live-Vorschläge, Tastatur-Navigation, SKU-Query → direkt zum Produkt ----

   SICHERHEIT: Die Antwort von /search/suggest.json ist FREMDER Text (Produkttitel und
   -URLs kommen aus der Produktpflege). Früher wurde daraus ein HTML-String gebaut und
   per innerHTML gesetzt; die Escape-Funktion deckte nur & < > " ab und liess ausserdem
   javascript:-URLs in href/src unangetastet. Jetzt wird JEDER Knoten einzeln erzeugt und
   Text ausschliesslich über textContent gesetzt — es gibt keinen HTML-Pfad mehr —, und
   jede URL muss vorher durch safeUrl() (nur http/https, an der eigenen Herkunft aufgelöst).
   ZUSTÄNDE: laden · leer · Fehler (mit Ursache + nächstem Schritt) · Treffer · Zuletzt gesucht. */
(function(){
  var FIELDS = 'title,product_type,variants.title,variants.sku';
  var seq = 0;

  /* ---- „Zuletzt gesucht“ (R24 Luxe, Runde 3) ----
     Nur die EIGENEN, abgeschickten Suchbegriffe dieser Besucherin, nur in diesem Browser
     (localStorage r24_recent_q, JSON-Liste). Hoechstens 5, neueste zuerst; derselbe Begriff
     in anderer Gross-/Kleinschreibung zaehlt einmal (die neueste Schreibweise bleibt).
     Kein Abruf, kein Versand: die Liste verlaesst das Geraet nie und wird nie mit Shopify-
     Vorschlaegen vermischt. Sichtbar nur bei leerem, fokussiertem Feld; „Verlauf löschen“
     leert sie sofort. Text ausschliesslich per textContent (siehe SICHERHEIT oben).
     Gesperrter Speicher (privates Fenster, Blocker): Funktion entfaellt still fuer die
     Kundin, die Konsole bekommt eine Warnung — die Suche selbst laeuft unveraendert. */
  /* Verfallsdatum (Review Q1): 30 Tage nach der letzten Suche wird der Verlauf beim naechsten
     Lesen geloescht — er bleibt nicht unbegrenzt auf dem Geraet. */
  var RECENT_KEY = 'r24_recent_q', RECENT_TS = 'r24_recent_q_ts', RECENT_TTL = 30 * 864e5, RECENT_MAX = 5, RECENT_LEN = 80;
  function recentClean(t){ return String(t == null ? '' : t).replace(/\s+/g, ' ').trim().slice(0, RECENT_LEN); }
  function recentRead(){
    var raw = null, list;
    try { raw = window.localStorage.getItem(RECENT_KEY); }
    catch(e){ console.warn('[R24 Suche] Suchverlauf nicht lesbar:', e && e.message); return []; }
    if (!raw) return [];
    try {
      var ts = parseInt(window.localStorage.getItem(RECENT_TS), 10);
      if (ts && Date.now() - ts > RECENT_TTL) { recentWrite([]); return []; }   /* jede Schreibung setzt ts */
    } catch(e){ console.warn('[R24 Suche] Suchverlauf-Datum nicht lesbar:', e && e.message); return []; }
    try { list = JSON.parse(raw); }
    catch(e){ console.warn('[R24 Suche] Suchverlauf unlesbar, wird ignoriert:', e && e.message); return []; }
    if (!Array.isArray(list)) return [];
    var out = [], seen = {};
    list.forEach(function(t){
      if (typeof t !== 'string') return;
      t = recentClean(t);
      var k = t.toLowerCase();
      if (t.length < 2 || seen[k]) return;
      seen[k] = 1; out.push(t);
    });
    return out.slice(0, RECENT_MAX);
  }
  function recentWrite(list){
    try {
      if (list.length) { window.localStorage.setItem(RECENT_KEY, JSON.stringify(list)); window.localStorage.setItem(RECENT_TS, String(Date.now())); }
      else { window.localStorage.removeItem(RECENT_KEY); window.localStorage.removeItem(RECENT_TS); }
      return true;
    } catch(e){ console.warn('[R24 Suche] Suchverlauf nicht speicherbar:', e && e.message); return false; }
  }
  function recentAdd(q){
    q = recentClean(q);
    if (q.length < 2) return;                    /* wie die Vorschlaege: ab 2 Zeichen */
    var k = q.toLowerCase();
    var list = recentRead().filter(function(t){ return t.toLowerCase() !== k; });
    list.unshift(q);
    recentWrite(list.slice(0, RECENT_MAX));
  }
  var ICON_R = 'M3.5 12a8.5 8.5 0 1 0 2.6-6.1L3.5 8.5M3.5 3.5v5h5M12 7.5V12l3 2';
  function eur(v){ var n = parseFloat(v); if (isNaN(n)) return '';
    try { return n.toLocaleString('de-DE', { style:'currency', currency:'EUR' }); }
    catch(e){ return n.toFixed(2).replace('.', ',') + ' €'; } }
  /* Nur http/https zulassen — relative Pfade und //cdn…-Adressen werden an der eigenen
     Herkunft aufgelöst. Alles andere (javascript:, data:, …) ergibt einen leeren Wert. */
  function safeUrl(u){
    if (!u) return '';
    try {
      var url = new URL(String(u), window.location.origin);
      return (url.protocol === 'http:' || url.protocol === 'https:') ? url.href : '';
    } catch(e){ return ''; }
  }
  function thumb(u){ return u ? String(u).replace(/(\.[a-zA-Z]+)(\?|$)/, '_96x$1$2') : ''; }
  function isCode(q){ return /\d/.test(q) && /^\S+$/.test(q) && q.length >= 4; } // SKU/Modellcode-artig
  /* EIN Abruf: Produkte, Suchbegriffe (Shopifys Korrektur/Vervollstaendigung, z. B.
     „kuchne“ → „küche“) und Kategorien/Serien (Kollektionen), je bis zu `limit`. */
  function suggestUrl(q, limit){ return '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,query,collection&resources[limit]=' + limit
      + '&resources[limit_scope]=each'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=' + FIELDS; }
  /* Ergebnisseite immer mit Praefix-Suche: „hängesch“ findet „Hängeschrank“. */
  function searchUrl(q){ return '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }
  function norm(t){ return String(t || '').toLowerCase().replace(/ä/g,'a').replace(/ö/g,'o').replace(/ü/g,'u').replace(/ß/g,'ss').replace(/\s+/g,' ').trim(); }
  var ICON_Q = 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm9.3 16.3-4-4';
  var ICON_C = 'M3 7h7l2 2h9v10H3z';
  var ICON_T = 'M3 17l6-6 4 4 8-8M15 7h6v6';
  function icon(d){
    var ns = 'http://www.w3.org/2000/svg', sv = document.createElementNS(ns, 'svg'), pa = document.createElementNS(ns, 'path');
    sv.setAttribute('viewBox', '0 0 24 24'); sv.setAttribute('width', '16'); sv.setAttribute('height', '16'); sv.setAttribute('aria-hidden', 'true');
    sv.setAttribute('fill', 'none'); sv.setAttribute('stroke', 'currentColor'); sv.setAttribute('stroke-width', '2'); sv.setAttribute('stroke-linecap', 'round');
    pa.setAttribute('d', d); sv.appendChild(pa);
    var w = el('span', 'r24hd-sd__ic'); w.appendChild(sv); return w;
  }
  function el(tag, cls, text){
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  document.querySelectorAll('.r24hd-search__form').forEach(function(form){
    var input = form.querySelector('.r24hd-search__input'); if (!input) return;
    var wrap = form.parentNode; wrap.style.position = 'relative';
    var uid = 'r24hd-sd-' + (++seq);
    /* Aufbau (Polish M4): .r24hd-sd ist nur der Rahmen des Aufklappers. Die Auswahlliste
       (role=listbox, Ziel von aria-controls) enthaelt AUSSCHLIESSLICH Optionen bzw.
       beschriftete Gruppen — Kopfzeile + „Verlauf löschen“, „Alle Ergebnisse“, Lade-,
       Leer- und Fehlerhinweis stehen daneben im Rahmen. Vorher war der Rahmen selbst die
       listbox: ein Knopf und Ueberschriften mitten in einer Auswahlliste. Die Liste bleibt
       immer im Rahmen (aria-controls zeigt nie ins Leere) und ist ohne Optionen verborgen. */
    var panel = document.createElement('div');
    panel.className = 'r24hd-sd';
    var lb = document.createElement('div');
    lb.className = 'r24hd-sd__lb'; lb.id = uid;
    lb.setAttribute('role','listbox');
    lb.setAttribute('aria-label','Suchvorschläge');
    lb.hidden = true;
    panel.appendChild(lb);
    wrap.appendChild(panel);
    /* Unsichtbare Statuszeile — Screenreader hören „3 Vorschläge" / den Fehlertext. */
    var status = el('span', null, '');
    status.setAttribute('aria-live','polite');
    status.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
    wrap.appendChild(status);

    input.setAttribute('role','combobox');
    input.setAttribute('aria-autocomplete','list');
    input.setAttribute('aria-controls', uid);
    input.setAttribute('aria-expanded','false');

    var active = -1, tmr = null, lastQ = '', ctrl = null, hasItems = false;
    function close(){
      panel.classList.remove('is-open'); active = -1;
      input.setAttribute('aria-expanded','false');
      input.removeAttribute('aria-activedescendant');
    }
    function open(){ panel.classList.add('is-open'); input.setAttribute('aria-expanded','true'); }
    function rows(){ return lb.querySelectorAll('.r24hd-sd__row'); }
    function setActive(list){
      list.forEach(function(r,i){
        var on = (i === active);
        r.classList.toggle('is-active', on);
        r.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on){ r.scrollIntoView({block:'nearest'}); input.setAttribute('aria-activedescendant', r.id); }
      });
      if (active < 0) input.removeAttribute('aria-activedescendant');
    }
    /* Leert Rahmen und Liste; die (verborgene) Liste haengt danach wieder im Rahmen. */
    function clear(){
      while (lb.firstChild) lb.removeChild(lb.firstChild);
      while (panel.firstChild) panel.removeChild(panel.firstChild);
      lb.hidden = true;
      panel.appendChild(lb);
    }
    /* Liste mit Namen zeigen — nach allem, was im Rahmen davor steht (Kopfzeile). */
    function showList(label, labelledby){
      if (labelledby){ lb.removeAttribute('aria-label'); lb.setAttribute('aria-labelledby', labelledby); }
      else { lb.removeAttribute('aria-labelledby'); lb.setAttribute('aria-label', label); }
      panel.appendChild(lb);                     /* verschiebt sie ans Ende des Rahmens */
      lb.hidden = false;
    }

    /* --- Zustand: Zuletzt gesucht (leeres Feld, kein Abruf) --- */
    function renderRecent(){
      var list = recentRead();
      if (!list.length) return false;
      clear();
      /* Kopfzeile mit „Verlauf löschen“ VOR der Liste, nicht in ihr; sie benennt die Liste. */
      var hd = el('div','r24hd-sd__hdrow');
      var hdt = el('div','r24hd-sd__hd','Zuletzt gesucht');
      hdt.id = uid + '-rh';
      hd.appendChild(hdt);
      var del = el('button','r24hd-sd__clear','Verlauf löschen');
      del.type = 'button';
      del.addEventListener('click', function(e){
        e.preventDefault();
        recentWrite([]);
        clear(); close(); hasItems = false;
        status.textContent = 'Suchverlauf gelöscht.';
        input.focus();
      });
      hd.appendChild(del);
      panel.appendChild(hd);
      showList(null, hdt.id);
      list.forEach(function(t, i){
        var row = textRow('r', i, searchUrl(t), t, ICON_R);
        row.addEventListener('click', function(){ recentAdd(t); });   /* wieder nach oben */
        lb.appendChild(row);
      });
      status.textContent = 'Zuletzt gesucht: ' + list.length + (list.length === 1 ? ' Begriff.' : ' Begriffe.');
      hasItems = false;                          /* Treffer-Zustand gehoert zu Eingaben ab 2 Zeichen */
      active = -1; open();
      return true;
    }

    /* --- Zustand: Oft gesucht (leeres Feld ohne eigenen Verlauf; Phase 4, 02.11.2026) ---
       Begriffe aus data-r24hd-pop (Shop-Metafeld r24.beliebte_suchen, Nacht-Routine aus echten Suchen). */
    function renderPop(){
      var pop = [];
      try { pop = JSON.parse(form.getAttribute('data-r24hd-pop') || '[]'); } catch (e) { pop = []; }
      if (!Array.isArray(pop)) pop = [];
      pop = pop.filter(function(t){ return typeof t === 'string' && t.length > 1; }).slice(0, 8);
      if (!pop.length) return false;
      clear();
      var hdt = el('div','r24hd-sd__hd','Oft gesucht');
      hdt.id = uid + '-ph';
      panel.appendChild(hdt);
      showList(null, hdt.id);
      pop.forEach(function(t, i){
        var lbl = t.split(' ').map(function(w){ return w === 'cm' ? w : w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
        var row = textRow('pop', i, searchUrl(t), lbl, ICON_T);
        row.addEventListener('click', function(){ recentAdd(t); });
        lb.appendChild(row);
      });
      status.textContent = 'Oft gesucht: ' + pop.length + ' Begriffe.';
      hasItems = false;
      active = -1; open();
      return true;
    }

    /* --- Zustand: lädt --- */
    function renderLoading(){
      clear(); panel.appendChild(el('div','r24hd-sd__spin','Suche …'));
      active = -1; open();
    }
    /* --- Zustand: Fehler (Ursache + nächster Schritt + Wiederholen) --- */
    /* Ursache auf Deutsch benennen — „Failed to fetch" sagt einer Kundin nichts. */
    function ursache(e){
      var m = (e && e.message) ? String(e.message) : '';
      if (/^HTTP 5/.test(m)) return 'der Shop antwortet gerade nicht';
      if (/^HTTP 429/.test(m)) return 'der Shop ist gerade ausgelastet';
      if (/^HTTP 4/.test(m)) return 'die Vorschlagsadresse ist nicht erreichbar';
      if (/JSON|Unexpected/i.test(m)) return 'die Antwort war unlesbar';
      return 'keine Verbindung';
    }
    function renderError(q, cause){
      clear();
      var box = el('div','r24hd-sd__err');
      box.appendChild(el('span', null, 'Vorschläge nicht verfügbar — ' + cause + '. Die Suche selbst funktioniert weiter: mit Enter geht es zur vollständigen Ergebnisliste.'));
      var again = el('button', null, 'Erneut versuchen');
      again.type = 'button';
      again.addEventListener('click', function(){ lastQ = ''; fetchSug(q); input.focus(); });
      box.appendChild(again);
      panel.appendChild(box);
      status.textContent = 'Suchvorschläge nicht erreichbar.';
      hasItems = false; active = -1; open();
    }
    /* --- Zustand: leer / Treffer --- */
    function textRow(kind, i, href, text, d){
      var row = el('a','r24hd-sd__row r24hd-sd__row--' + kind);
      row.id = uid + '-' + kind + i;
      row.setAttribute('role','option');
      row.setAttribute('aria-selected','false');
      row.href = href;
      row.appendChild(icon(d));
      var body = el('span','r24hd-sd__body');
      body.appendChild(el('span','r24hd-sd__t', text));
      row.appendChild(body);
      return row;
    }
    /* Beschriftete Gruppe in der Liste: die sichtbare Ueberschrift ist nur Optik
       (aria-hidden), den Namen traegt die Gruppe selbst. */
    function group(label){
      var g = el('div','r24hd-sd__grp');
      g.setAttribute('role','group');
      g.setAttribute('aria-label', label);
      var h = el('div','r24hd-sd__hd', label);
      h.setAttribute('aria-hidden','true');
      g.appendChild(h);
      lb.appendChild(g);
      return g;
    }
    function render(q, products, queries, cols){
      queries = queries || []; cols = cols || [];
      hasItems = products.length > 0 || queries.length > 0 || cols.length > 0;
      clear();
      if (!hasItems){
        panel.appendChild(el('div','r24hd-sd__empty','Keine Treffer für „' + q + '“. Prüfen Sie die Schreibweise oder die Modell- bzw. Artikelnummer.'));
        status.textContent = 'Keine Treffer.';
        active = -1; open(); return;
      }
      /* Suchbegriffe: Korrektur/Vervollstaendigung — der eigene Begriff faellt weg. */
      showList('Suchvorschläge');
      if (queries.length){
        var gq = group('Suchbegriffe');
        queries.forEach(function(t, i){ gq.appendChild(textRow('q', i, searchUrl(t), t, ICON_Q)); });
      }
      if (cols.length){
        var gc = group('Kategorien');
        cols.forEach(function(c, i){ gc.appendChild(textRow('c', i, c.url, c.title, ICON_C)); });
      }
      var gp = products.length ? group('Produkte') : null;
      products.forEach(function(p,i){
        var href = safeUrl(p.url);
        if (!href) return;                       /* unbrauchbare URL → Zeile weglassen */
        var row = el('a','r24hd-sd__row');
        row.id = uid + '-o' + i;
        row.setAttribute('role','option');
        row.setAttribute('aria-selected','false');
        row.href = href;
        var img = safeUrl(thumb(p.image));
        if (img){
          var im = el('img','r24hd-sd__img');
          im.src = img; im.alt = ''; im.loading = 'lazy'; im.width = 46; im.height = 46;
          row.appendChild(im);
        } else {
          row.appendChild(el('span','r24hd-sd__img'));
        }
        var body = el('span','r24hd-sd__body');
        body.appendChild(el('span','r24hd-sd__t', p.title == null ? '' : String(p.title)));
        var meta = el('span','r24hd-sd__meta');
        if (p.price != null) meta.appendChild(el('span','r24hd-sd__price', eur(p.price)));
        body.appendChild(meta);
        row.appendChild(body);
        gp.appendChild(row);
      });
      /* „Alle Ergebnisse“ ist ein Verweis NEBEN der Liste (keine Option). */
      var all = el('a','r24hd-sd__all','Alle Ergebnisse für „' + q + '“');
      all.href = searchUrl(q);
      all.addEventListener('click', function(){ recentAdd(q); });   /* eigene Eingabe, abgeschickt */
      panel.appendChild(all);
      status.textContent = (products.length + queries.length + cols.length) + ' Vorschläge.';
      active = -1; open();
    }

    function fetchSug(q){
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      renderLoading();
      fetch(suggestUrl(q, 7), { signal: ctrl ? ctrl.signal : undefined })
        .then(function(r){
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function(d){
          var res = ((d.resources||{}).results) || {};
          var ps = res.products || [];
          var own = norm(q), qseen = {}, qs = [];
          qseen[own] = 1;
          (res.queries || []).forEach(function(x){ var t = String((x && x.text) || '').trim(), k = norm(t); if (!t || qseen[k]) return; qseen[k] = 1; qs.push(t); });
          var cseen = {}, cs = [];
          (res.collections || []).forEach(function(c){ var t = String((c && c.title) || '').trim(), u = safeUrl(c && c.url), k = norm(t); if (!t || !u || cseen[k]) return; cseen[k] = 1; cs.push({ title: t, url: u }); });
          render(q, ps.map(function(p){ return { title:p.title, url:p.url, image:p.image, price:p.price }; }), qs.slice(0, 3), cs.slice(0, 3));
        })
        .catch(function(e){
          if (e && e.name === 'AbortError') return;   /* durch die nächste Eingabe ersetzt */
          renderError(q, ursache(e));
        });
    }

    input.addEventListener('input', function(){
      var q = input.value.trim();
      if (q.length < 2){
        /* Ein noch wartender Abruf fuer den geloeschten Begriff darf nicht nachtraeglich
           Vorschlaege ueber das leere Feld legen. */
        clearTimeout(tmr); if (ctrl) ctrl.abort();
        lastQ = '';
        if (!q && (renderRecent() || renderPop())) return;
        close(); return;
      }
      if (q === lastQ) return; lastQ = q;
      clearTimeout(tmr); tmr = setTimeout(function(){ fetchSug(q); }, 170);
    });
    input.addEventListener('focus', function(){
      var q = input.value.trim();
      if (!q){ renderRecent() || renderPop(); return; }
      if (hasItems && q.length >= 2) open();
    });
    input.addEventListener('keydown', function(e){
      var list = rows();
      if (e.key === 'ArrowDown'){ e.preventDefault(); active = Math.min(active+1, list.length-1); setActive(list); }
      else if (e.key === 'ArrowUp'){ e.preventDefault(); active = Math.max(active-1, -1); setActive(list); }
      else if (e.key === 'Escape'){ close(); }
      else if (e.key === 'Enter' && active >= 0 && list[active]){
        e.preventDefault();
        if (list[active].classList.contains('r24hd-sd__row--r')) recentAdd(list[active].textContent);
        window.location = list[active].href;
      }
    });

    // Smart submit: SKU-/Code-Query mit genau einem Treffer → direkt zum Produkt (statt leerer Ergebnisseite,
    // da die Liquid-Volltextsuche SKU nicht indexiert). Sonst normale Ergebnisseite.
    // Der Absprung darf nie hängen: nach 4 s bricht die Abfrage ab und die normale Ergebnisseite gewinnt.
    var submitting = false;
    form.addEventListener('submit', function(e){
      var q = input.value.trim(); if (!q) return;
      recentAdd(q);                                /* „Zuletzt gesucht“: nur hier und bei eigenen Klicks */
      if (!isCode(q)) return; // normale Begriffe → Standard-Ergebnisseite
      e.preventDefault();
      if (submitting) return;
      submitting = true;
      form.setAttribute('aria-busy','true');
      renderLoading();
      var go = searchUrl(q);
      var sctrl = ('AbortController' in window) ? new AbortController() : null;
      var bail = setTimeout(function(){ if (sctrl) sctrl.abort(); window.location = go; }, 4000);
      fetch(suggestUrl(q, 3), { signal: sctrl ? sctrl.signal : undefined })
        .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function(d){
          clearTimeout(bail);
          var ps = (((d.resources||{}).results||{}).products) || [];
          var one = (ps.length === 1) ? safeUrl(ps[0].url) : '';
          window.location = one || go;
        })
        .catch(function(){ clearTimeout(bail); window.location = go; });
    });

    document.addEventListener('click', function(e){ if (!wrap.contains(e.target)) close(); });
  });
})();
